import { Toolbar, Link, f7, f7ready } from 'framework7-react';
import { useEffect, useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { TEMPORARY_TAB_FLAGS } from '../config/featureFlags';

import LearnIcon from '@assets/icons/learn.svg?react';
import SupportIcon from '@assets/icons/Call.svg?react';
import StatusReviewIcon from '@assets/icons/statusReview.svg?react';
import MoreIcon from '@assets/icons/more.svg?react';

import '@styles/BottomTabBar.css';

export const BottomTabBar = () => {
  const [activePath, setActivePath] = useState<string>('');
  const { loadingAuth, isAuthenticated } = useAuth(false);

  useEffect(() => {
    f7ready(() => {
      const updatePath = () => {
        const path = f7?.views?.main?.router?.currentRoute?.path || '';
        setActivePath(path);
      };

      updatePath();
      f7.views.main.router.on('routeChange', updatePath);

      return () => {
        f7.views.main.router.off('routeChange', updatePath);
      };
    });
  }, []);

  if (loadingAuth || !isAuthenticated) return null;

  const handleNavigation = (path: string) => {
    if (path !== activePath) {
      f7.views.main.router.navigate(path, { animate: false });
      setActivePath(path);
    }
  };

  return (
    <Toolbar
      tabbar
      position="bottom"
      className="custom-tabbar no-outline"
      data-testid="tabbar-dashboard"
    >
      <Link
        className={`tab-link ${activePath === '/support' ? 'tab-link-active' : ''}`}
        onClick={() => handleNavigation('/support')}
        data-testid="tab-support"
      >
        <SupportIcon className="tabbar-icon" />
        <span className="tabbar-label">Support</span>
      </Link>

      {TEMPORARY_TAB_FLAGS.showStatusReview && (
        <Link
          className={`tab-link ${activePath === '/access' ? 'tab-link-active' : ''}`}
          onClick={() => handleNavigation('/access')}
          data-testid="tab-access"
        >
          <StatusReviewIcon className="tabbar-icon" />
          <span className="tabbar-label">Status Review</span>
        </Link>
      )}

      {TEMPORARY_TAB_FLAGS.showLearn && (
        <Link
          className={`tab-link ${activePath === '/videos' ? 'tab-link-active' : ''}`}
          onClick={() => handleNavigation('/videos')}
          data-testid="tab-learn"
        >
          <LearnIcon className="tabbar-icon" />
          <span className="tabbar-label">Learn</span>
        </Link>
      )}

      <Link
        className={`tab-link ${activePath === '/more' ? 'tab-link-active' : ''}`}
        onClick={() => handleNavigation('/more')}
        data-testid="tab-more"
      >
        <MoreIcon className="tabbar-icon" />
        <span className="tabbar-label">More</span>
      </Link>
    </Toolbar>
  );
};
